import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "sliding-line-cards overflow-hidden" },
    _vm._l(_setup.doctorRatesByLines, function (doctorRatesByLine, lineIndex) {
      return _c(
        "div",
        {
          key: `doctor-rates-${lineIndex}`,
          staticClass: "d-flex align-self-center",
        },
        [
          _c(
            "div",
            {
              staticClass: "sliding-line-cards__line gc-4 px-4",
              class: lineIndex === 0 ? "align-end" : "align-start",
              style: { animationPlayState: _setup.animationState },
            },
            _vm._l(doctorRatesByLine, function (doctorRate, doctorRateIndex) {
              return _c(
                "div",
                {
                  key: `doctor-rate-${doctorRate.doctor.id}-${doctorRateIndex}`,
                  staticClass:
                    "d-flex flex-column gr-8 pa-6 elevation-1 rounded-sm",
                  style: { width: doctorRate.width },
                },
                [
                  _c("div", { staticClass: "text-body-1 text--text" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(doctorRate.rateText) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex gc-4" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-decoration-none",
                        attrs: {
                          href: `/${doctorRate.doctor.url}`,
                          target: "_blank",
                          rel: "noopener noreferrer",
                        },
                      },
                      [
                        _c(VImg, {
                          attrs: {
                            src: doctorRate.doctor.avatar,
                            alt: _setup.t("Аватар", _setup.options),
                            width: "48",
                            height: "48",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex flex-column" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "text-subtitle-1 text-decoration-none primary--text",
                          attrs: { href: `/${doctorRate.doctor.url}` },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _setup.transDynamic(
                                  doctorRate.doctor,
                                  `fio,${_setup.languageIso},${_setup.needTranslate}`
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "text-body-1 text-info--text" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _setup.transDynamic(
                                  doctorRate.doctor,
                                  `meta,${_setup.languageIso},${_setup.needTranslate}`
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }